import * as S from "../ContextMenu/ContextMenu.style"; // 위에서 만든 스타일드 컴포넌트 파일

interface ContextMenuProps {
  visible: boolean;
  x: number;
  y: number;
  handleOpenInNewTab: (callback: Function) => void;
  setModalShow?: () => void;
}
const DiagnosisContextMenu = ({
  visible,
  x,
  y,
  handleOpenInNewTab,
  setModalShow,
}: ContextMenuProps) => {
  return (
    <S.ContextMenu $visible={visible} style={{ top: y, left: x }}>
      <S.ContextMenuItem onClick={() => handleOpenInNewTab(setModalShow!)}>
        상태진단 탭으로 이동
      </S.ContextMenuItem>
    </S.ContextMenu>
  );
};

export default DiagnosisContextMenu;
